export default "__VITE_ASSET__ncIpufyC__"